import React from 'react';
import { Text, TouchableOpacity } from 'react-native';

//= ========================================================================

const LinkTextButton = ({
  children,
  onPress,
  left,
  width,
}) => {
  const myStyles = {
    touchableOpacityStyle: {
      width,
    },
    textStyle: {
      textAlign: left ? 'left' : 'right',
      color: '#008cff',
    },
  };
  return (
    <TouchableOpacity
      onPress={onPress}
      style={myStyles.touchableOpacityStyle}
    >
      <Text style={myStyles.textStyle}>
        {children}
      </Text>
    </TouchableOpacity>
  );
};
export default LinkTextButton;
